// extracted by mini-css-extract-plugin
export default {"banner":"PrivacyBanner-banner","bannerContent":"PrivacyBanner-bannerContent","bannerLink":"PrivacyBanner-bannerLink","info":"PrivacyBanner-info"};